module.exports = __webpack_public_path__ + "static/img/bigData.83a8e3bd.png";